









import Vue from 'vue';

export default Vue.extend({
    name: 'CardGallery',

    props: {
        title: String,
        isMobile: {
            type: Boolean,
            default: true
        }
    }
});
